import { createContext } from 'react';
export var PreferencesEditorContext = createContext(undefined);
//# sourceMappingURL=PreferencesEditorContext.js.map